/**
 * Wiliot adapter — IOT-Z20-AMBIENT-SCAFFOLD-1 (ASPIRATIONAL).
 *
 * Wiliot ships passive Bluetooth IoT pixels: paper-thin, battery-free stickers
 * that harvest RF energy from nearby radios and report telemetry to gateways.
 * Per-SKU sensing at near-zero unit cost — the canonical ambient IoT
 * primitive for 2028+ deployments.
 *
 * Operational status: ASPIRATIONAL — type-system awareness only. Activation
 * deferred until the hardware viability curve crosses for ambient beacons.
 * All DeviceContract methods throw VendorNotIntegratedError today; identity
 * and lifecycle methods work so HalService can route and inspect the device.
 *
 * Patent priority anchor: F-AMBIENT-IOT-PER-SKU-001.
 * Scaffold session: IOT-Z20-AMBIENT-SCAFFOLD-1.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const WILIOT_CAPABILITIES = {
  configKeys: {},
  telemetryTypes: ['temperature_c', 'humidity_pct'],
  alertingMode: 'cloud',
  otaSupported: false,
  attestationSupported: false,
  rollbackSupported: false,
  pushLatencyExpectedMs: 0,
};

export class WiliotAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'wiliot', WILIOT_CAPABILITIES);
  }
}

export function createWiliotAdapterFactory() {
  return (device) => new WiliotAdapter(device);
}
